import React, { useState } from "react";
import { Row, Col, CardBody, Card, Container, Input, Label } from "reactstrap";
import vidSrc from "~/assets/images/vid1.svg";
import info from '~/assets/images/info.svg';

type InstructionsProps = {
  next: (name: string, termsAccepted: boolean) => void;
  consent: (termsAccepted: boolean, name: string) => void;
  accepted: boolean;
  customerName: string;
}

const Instructions = ({ next, consent, accepted, customerName }: InstructionsProps) => {

  const [termsAccepted, setTermsAccepted] = useState(accepted);
  const [name, setName] = useState(customerName);

  const handleTermsChange = (event: any) => {
    setTermsAccepted(event.target.checked)
  }

  const handleNameChange = (event: any) => {
    setName(event.target.value);
  }

  return <React.Fragment>
    <div id="id_instructions" className="account-pages">
      <Container>
        <div className="header-image-box">
          <img className="header-image" src={vidSrc} />
        </div>
        <Row className="justify-content-center mx-0">
          <Col md={9} lg={6} xl={5} className="vid-column mb-5">
            <Card className="overflow-hidden">
              <CardBody className="pt-3">
                <div className="p-2 mb-2">
                  <h5 className="confirm-title text-center">Scan your driver license/passport and take a selfie to confirm your identity</h5>
                </div>
                <div className="d-flex fade show alert-box">
                  <img src={info} className="mx-2" />
                  <span className="my-2 sure-text">Temporary IDs or paper IDs are not valid</span>
                </div>
                <div className="mt-4 mb-1 consent-signer-name-label">First and Last Name</div>
                <Input type="text" className="form-control consent-signer-name" placeholder="Enter your name" onChange={handleNameChange} value={name} />
                <div className="consent-wrapper">
                  <div className="form-check form-switch form-switch-lg">
                    <Input
                      type="checkbox"
                      name="terms-consent"
                      onChange={handleTermsChange}
                      id="termsConsentCheck"
                      className="form-check-input-lg me-2"
                      defaultChecked={accepted}
                    />
                    <Label className="form-check-label" htmlFor="terms-consent" />
                  </div>
                  <button id="consentClick" className="ms-0 pt-1" onClick={() => consent(termsAccepted, name)}>Consent to <u>the use and release of my digital photograph</u></button>
                </div>
              </CardBody>
            </Card>

            <button className={`btn btn-primary w-100 start-btn-mobile ${!termsAccepted || !name.trim() ? "disabled" : ""}`} onClick={() => next(name, termsAccepted)}>Start ID verification</button>
          </Col>
        </Row>
      </Container>
    </div>
  </React.Fragment>
}

export default Instructions;